import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useRecoilState, atom } from 'recoil';
import { _showstoryofliferesults } from '../RecoilState';
import { useNavigate } from 'react-router-dom';


const AllResults = () => {
    const [allResults, setAllResults] = useState([]);
    const [visibleResults, setVisibleResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showStoryOfLifeResults, setShowStoryOfLifeResults] = useRecoilState(_showstoryofliferesults);
    const loaderRef = useRef(null);
    const observer = useRef();
    const itemsPerPage = 20;
    const correctPassword = "AllSOLReports";

    // /rzfabmfn <- Access URL
    // AllSOLReports <- Access Password

    // Fetch all data on initial load
    useEffect(() => {
        if (showStoryOfLifeResults === correctPassword) {
            setLoading(true);
            axios.get('https://yanchacms.metadei.in/wp-json/story-of-life/v1/all')
                .then((response) => {
                    setAllResults(response.data);
                    setVisibleResults(response.data.slice(0, itemsPerPage));
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    }, [showStoryOfLifeResults]);

    // Intersection Observer to detect when to load more
    useEffect(() => {
        if (showStoryOfLifeResults !== correctPassword) return;

        const options = {
            root: null,
            rootMargin: '20px',
            threshold: 1.0,
        };

        observer.current = new IntersectionObserver(handleObserver, options);
        if (loaderRef.current) observer.current.observe(loaderRef.current);

        return () => observer.current?.disconnect();
    }, [visibleResults, showStoryOfLifeResults]);

    const handleObserver = (entities) => {
        const target = entities[0];
        if (target.isIntersecting && !loading && hasMore) {
            setLoading(true);
            setTimeout(() => {
                const nextBatch = allResults.slice(
                    visibleResults.length,
                    visibleResults.length + itemsPerPage
                );
                if (nextBatch.length === 0) {
                    setHasMore(false);
                } else {
                    setVisibleResults((prev) => [...prev, ...nextBatch]);
                }
                setLoading(false);
            }, 1000);
        }
    };

    const filteredResults = visibleResults.filter(item =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handlePasswordSubmit = () => {
        if (showStoryOfLifeResults === correctPassword) {
            setShowStoryOfLifeResults(true);
        } else {
            alert("Incorrect showStoryOfLifeResults");
        }
    };

    const navigate = useNavigate();

    const showResult = (result) => { 
        console.log(result) 
        navigate(`/rzfabmfn/${result}`);
    };

    const IndividualResultCard = ({ result }) => (
        <div className='p-3 border-[1px] border-black rounded'>
            <div className='flex flex-row gap-3'>
                <div className='w-3/4 brand-text txt-color'>
                    <p className='sub-heading pb-[10px]'>{result.title}</p>
                    <p>{result.date}</p>
                </div>
                <div className='w-1/4 flex flex-col items-center justify-center brand-text txt-color'>
                    <button className='border-[2px] p-3' onClick={() => showResult(result.id)}>View</button>
                </div>
            </div>
        </div>
    );

    return (
        <div className='flex flex-col'>
            {showStoryOfLifeResults !== correctPassword ? (
                <div className='flex flex-col items-center justify-center h-screen'>
                    <h2 className='text-xl mb-4'>Enter showStoryOfLifeResults to View Results</h2>
                    <input
                        type="showStoryOfLifeResults"
                        placeholder="showStoryOfLifeResults"
                        value={showStoryOfLifeResults}
                        onChange={(e) => setShowStoryOfLifeResults(e.target.value)}
                        className="border p-2 mb-4 w-64"
                    />
                    <button onClick={handlePasswordSubmit} className="border p-2 w-32">
                        Submit
                    </button>
                </div>
            ) : (
                <>
                    <p className='gradient-heading pb-[15px]'>Story Of Life Reports</p>

                    <input
                        type="text"
                        placeholder="Search by Phone Number"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="border p-2 mb-4 w-full"
                    />

                    <div className='flex flex-col gap-3'>
                        {filteredResults.map((result, index) => (
                            <IndividualResultCard key={`${result.id}-${index}`} result={result} />
                        ))}
                        <div ref={loaderRef} style={{ height: '20px' }}>
                            {loading && <p>Loading more results...</p>}
                            {!hasMore && <p>No more results to show</p>}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AllResults;
